import React from 'react'
import { Modal } from '../../../../UI'
import { FaUserPlus, FaUsers } from 'react-icons/fa'
import Container from './styles'

const AddRiderSelectionModal = ({ show, handleClose, onSelectExisting, onSelectNew }) => {
  return (
    <Modal showModal={show} onClose={handleClose} showCloseBtn={true}>
      <Container>
        <div className="selection--container">
          <header>
            <h2>Add Rider to Your Company</h2>
            <p>Choose how you want to add a rider</p>
          </header>

          <div className="options--grid">
            <div className="option--card" onClick={() => {
              handleClose()
              onSelectExisting()
            }}>
              <div className="icon--wrapper existing">
                <FaUsers />
              </div>
              <h3>Add Existing Rider</h3>
              <p>
                Assign a rider who already has an account on the platform to your company
              </p>
              <span className="badge">Recommended</span>
            </div>

            <div className="option--card" onClick={() => {
              handleClose()
              onSelectNew()
            }}>
              <div className="icon--wrapper new">
                <FaUserPlus />
              </div>
              <h3>Create New Rider</h3>
              <p>
                Create a new rider account and automatically assign them to your company
              </p>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  )
}

export default AddRiderSelectionModal
